import { Injectable, EventEmitter } from "@angular/core";
import { Http } from "@angular/http";
import { Configuration } from "../../shared/configurations/shared.config";



@Injectable()

export class PoliciesTabService {

    sensorSubmitted: EventEmitter<number> = new EventEmitter();

    constructor(private http: Http) { };

    getDefaultPolicy(vecID) {
        return this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetDefaultPolicy + vecID).map(res => res.json());
    };

    getPoliciesByGeofenceId(gid) {
        return this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetPoliciesByGeofenceId + gid).map(res => res.json());
    };

    getNotMonitor() {
        return this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetNotMonitor).map(res => res.json());
    };

    getRules(id) {
        return this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.RulesUrl + id).map(res => res.json());
    };

    SavePolicy(policyObject) {
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.SavePolicy, policyObject).map(res => res.json());
    };

    saveRules(rules) {
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.RulesUrl, rules).map(res => res.json());
    };

    SavePolicyGeofenceAssociation(associationObject) {
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.SavePolicyGeofenceAssociation, associationObject).map(res => res.json());
    };

    savePolicyVehicleRelation(vehicleAssociationList) {
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.VehicleAssociationUrl, vehicleAssociationList).map(res => res.json());
    };

    deletePolicy(policyId, geofenceId) {
        return this.http.delete(Configuration.urls.webApiEndpoint + Configuration.urls.DeletePolicy + policyId + "/" + geofenceId).map(res => res.json());
    };

    deleteRule(Id) {
        return this.http.delete(Configuration.urls.webApiEndpoint + Configuration.urls.RulesUrl + Id).map(res => res.json());
    };

    emitSensorsSubmittedEvent(vehicleID) {
        // console.log("emitSensorsSubmittedEvent", "vehicleID", vehicleID);
        this.sensorSubmitted.emit(vehicleID);
    }

    getSensorsSubmittedEmitter() {
        // console.log("getSensorsSubmittedEmitter");
        return this.sensorSubmitted;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/policies-tab-form.service.ts